import { n as a } from "./property-9daa16cd.mjs";
import { i as v, E as g, x as s, a as x, r as p } from "./createReactComponent-58f9bea8.mjs";
import { I as h, r as k } from "./icon-c572aa57.mjs";
import { r as y } from "./tooltip-cb602d1f.mjs";
function u(o) {
  var r, n, e = "";
  if (typeof o == "string" || typeof o == "number")
    e += o;
  else if (typeof o == "object")
    if (Array.isArray(o)) {
      var i = o.length;
      for (r = 0; r < i; r++)
        o[r] && (n = u(o[r])) && (e && (e += " "), e += n);
    } else
      for (n in o)
        o[n] && (e && (e += " "), e += n);
  return e;
}
function b() {
  for (var o, r, n = 0, e = "", i = arguments.length; n < i; n++)
    (o = arguments[n]) && (r = u(o)) && (e && (e += " "), e += r);
  return e;
}
const f = v`
  /** LIGHT MODE */
  :host .icon-button {
    position: relative;
    padding: var(--exo-spacing-3x-small);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    transition: background-color var(--exo-time-standard) ease,
      border-radius calc(2 * var(--exo-radius-small)) ease;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    font-size: var(--exo-font-size-3x-large);
    border: none;
    background-color: var(--exo-color-background-selected);
    color: var(--exo-color-icon-inverse);
    border-radius: calc(2 * var(--exo-radius-small));
    min-height: var(--exo-spacing-x-large);
    min-width: var(--exo-spacing-x-large);
  }

  :host .icon-button.icon-button--circular {
    border-radius: var(--exo-radius-circle);
  }

  :host .icon-button--size-small {
    font-size: var(--exo-font-size-medium);
    min-height: var(--exo-spacing-large);
    min-width: var(--exo-spacing-large);
  }

  :host .icon-button--size-x-small {
    font-size: var(--exo-font-size-medium);
    padding: 0;
    min-height: var(--exo-spacing-standard);
    min-width: var(--exo-spacing-standard);
  }

  :host
    .icon-button.icon-button--tertiary.icon-button--branded.icon-button--size-x-small.icon-button--circular:hover,
  .icon-button.icon-button--tertiary.icon-button--branded.icon-button--size-x-small.icon-button--circular:focus-visible {
    background-color: var(--exo-color-background-action-hover);
    color: var(--exo-color-icon-inverse);
    border: none;
    outline: none;
  }

  :host
    .icon-button.icon-button--tertiary.icon-button--branded.icon-button--size-x-small.icon-button--circular:not(
      :focus-visible
    ):not(:hover) {
    color: var(--exo-color-background-info-strong);
  }

  :host
    .icon-button.icon-button--tertiary.icon-button--branded.icon-button--size-x-small.icon-button--circular:active {
    background-color: var(--exo-color-background-action);
  }

  :host .icon-button:hover,
  .icon-button.hover {
    background-color: var(--exo-color-background-selected-hover);
  }

  :host .icon-button:active {
    background-color: var(--exo-color-background-selected);
    border-color: var(--exo-color-background-selected);
  }

  :host .icon-button:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    background-color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host [disabled].icon-button--primary.icon-button {
    pointer-events: none;
    cursor: not-allowed;
    background-color: var(--exo-color-background-disabled);
    border-color: var(--exo-color-background-disabled);
  }

  :host .icon-button.icon-button--secondary {
    color: var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected);
    background-color: var(--exo-color-background-action-secondary);
  }

  :host .icon-button.icon-button--secondary:hover {
    color: var(--exo-color-background-selected-hover);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected-hover);
    background-color: var(--exo-color-background-action-secondary-hover);
  }

  :host .icon-button.icon-button--secondary:active {
    color: var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-selected);
    background-color: var(--exo-color-background-action-secondary);
  }

  :host .icon-button.icon-button--secondary:focus-visible,
  :host .icon-button.icon-button--tertiary:focus-visible {
    color: var(--exo-color-background-selected);
    background-color: var(--exo-color-background-action-secondary-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
  }

  :host [disabled].icon-button--secondary.icon-button {
    pointer-events: none;
    cursor: not-allowed;
    color: var(--exo-color-background-disabled);
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-background-disabled);
  }

  :host .icon-button.icon-button--tertiary {
    background: none;
    color: var(--exo-color-background-selected);
    border: none;
  }

  :host .icon-button.icon-button--tertiary:hover {
    background-color: var(--exo-color-background-action-secondary-hover);
    border: none;
    color: var(--exo-color-background-selected-hover);
  }

  :host .icon-button.icon-button--tertiary:active {
    background-color: var(--exo-color-background-action-secondary);
    color: var(--exo-color-background-selected);
    border-color: var(--exo-color-background-action-secondary);
  }

  /* CSS for icon button for branded flavor  */

  :host .icon-button--branded.icon-button--primary {
    background-color: var(--exo-color-background-selected);
  }

  :host .icon-button--branded.icon-button--primary:hover {
    background-color: var(--exo-color-background-selected-hover);
  }

  :host .icon-button--branded.icon-button--primary:active {
    background-color: var(--exo-color-background-selected);
    border-color: var(--exo-color-background-selected);
  }

  :host .icon-button--branded.icon-button--primary:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    background-color: var(--exo-color-background-selected-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  :host .icon-button--branded.icon-button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-border);
    color: var(--exo-color-background-action);
  }

  :host .icon-button--branded.icon-button--secondary:hover {
    color: var(--exo-color-background-action-hover);
    background-color: var(--exo-color-background-action-hover-weak);
    border-color: var(--exo-color-background-action-hover);
  }

  :host .icon-button--branded.icon-button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    color: var(--exo-color-background-action);
    border-color: var(--exo-color-background-action);
  }

  :host .icon-button--branded.icon-button--secondary:focus-visible,
  :host .icon-button--branded.icon-button--tertiary:focus-visible {
    color: var(--exo-color-background-action-hover);
    background-color: var(--exo-color-background-action-hover-weak);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
  }

  :host .icon-button--branded.icon-button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-background-action);
  }

  :host .icon-button--branded.icon-button--tertiary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    color: var(--exo-color-background-action-hover);
  }

  :host .icon-button--branded.icon-button--tertiary:active {
    color: var(--exo-color-background-action);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    background-color: var(--exo-color-background-action-secondary);
  }

  /* CSS for icon button for risky flavor  */

  :host .icon-button--risky.icon-button--primary {
    background-color: var(--exo-color-background-danger-strong);
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-border-danger-strong);
  }

  :host .icon-button--risky.icon-button--primary:hover {
    background-color: var(--exo-color-background-danger-strong-hover);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-danger-strong-hover);
  }

  :host .icon-button--risky.icon-button--primary:active {
    background-color: var(--exo-color-background-danger-strong);
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-border-danger-strong);
  }

  :host .icon-button--risky.icon-button--primary:focus-visible {
    background-color: var(--exo-color-background-danger-strong-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
  }

  :host .icon-button--risky.icon-button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-background-danger-strong);
    color: var(--exo-color-background-danger-strong);
  }

  :host .icon-button--risky.icon-button--secondary:hover {
    border-color: var(--exo-color-background-danger-strong-hover);
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
  }

  :host .icon-button--risky.icon-button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-background-danger-strong);
    color: var(--exo-color-background-danger-strong);
  }

  :host .icon-button--risky.icon-button--secondary:focus-visible,
  :host .icon-button--risky.icon-button--tertiary:focus-visible {
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-danger-strong);
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-border-danger-extreme);
  }

  :host .icon-button--risky.icon-button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-background-danger-strong);
  }

  :host .icon-button--risky.icon-button--tertiary:hover {
    background-color: var(--exo-color-background-danger-weak);
    color: var(--exo-color-background-danger-strong-hover);
  }

  :host .icon-button--risky.icon-button--tertiary:active {
    background-color: var(--exo-color-background-action-secondary);
    border-color: var(--exo-color-background-action-secondary);
    color: var(--exo-color-background-danger-strong);
  }

  :host [disabled].icon-button--tertiary.icon-button {
    pointer-events: none;
    cursor: not-allowed;
    color: var(--exo-color-background-disabled);
  }

  /* CSS for icon button for periwinkle flavor  */

  :host .icon-button--periwinkle.icon-button--primary {
    background-color: var(--exo-color-surface-ai-action);
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle.icon-button--primary:hover {
    background-color: var(--exo-color-surface-ai-action-hover);
  }

  :host .icon-button--periwinkle.icon-button--primary:active {
    background-color: var(--exo-color-surface-ai-action);
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle.icon-button--primary:focus-visible {
    background-color: var(--exo-color-surface-ai-action-hover);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle-green.icon-button--primary {
    background: linear-gradient(
      90deg,
      var(--exo-color-data-solid-periwinkle) 0%,
      var(--exo-color-data-solid-green) 100%
    );
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle-green.icon-button--primary:hover {
    background: linear-gradient(
      90deg,
      var(--exo-color-data-solid-periwinkle) 50%,
      var(--exo-color-data-solid-green) 100%
    );
  }

  :host .icon-button--periwinkle-green.icon-button--primary:active {
    background: linear-gradient(
      90deg,
      var(--exo-color-data-solid-periwinkle) 75%,
      var(--exo-color-data-solid-green) 100%
    );
    color: var(--exo-color-font-inverse);
    border-color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkl-green.icon-button--primary:focus-visible {
    background: linear-gradient(
      90deg,
      var(--exo-color-data-solid-periwinkle) 51.56%,
      var(--exo-color-data-solid-green) 100%
    );
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
  }

  :host
    [disabled].icon-button--periwinkle-green.icon-button--primary.icon-button {
    background: var(--exo-color-background-disabled);
  }

  :host .icon-button--periwinkle.icon-button--secondary {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle.icon-button--secondary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-surface-ai-action-hover);
    color: var(--exo-color-surface-ai-action-hover);
  }

  :host .icon-button--periwinkle.icon-button--secondary:active {
    background-color: var(--exo-color-background-action-secondary);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-surface-ai-action);
    color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle.icon-button--secondary:focus-visible,
  :host .icon-button--periwinkle.icon-button--tertiary:focus-visible {
    background-color: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-surface-ai-action-hover);
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-surface-ai-action);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-page);
  }

  :host .icon-button--periwinkle.icon-button--tertiary {
    background: none;
    border: none;
    color: var(--exo-color-surface-ai-action);
  }

  :host .icon-button--periwinkle.icon-button--tertiary:hover {
    background-color: var(--exo-color-background-action-hover-weak);
    color: var(--exo-color-surface-ai-action-hover);
  }

  :host .icon-button--periwinkle.icon-button--tertiary:active {
    background-color: var(--exo-color-background-action-secondary);
    color: var(--exo-color-surface-ai-action);
  }

  :host([disabled]) {
    pointer-events: none;
  }

  /* --- Indicator Styles --- */
  :host .indicator {
    position: absolute;
    top: -2px;
    right: -2px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--exo-radius-medium, 8px);
    background-color: var(--exo-palette-coral-20, #ffcbc2);
    border: 1px solid var(--exo-palette-coral-50, #ff7c66);
    color: var(--exo-color-font-inverse, white);
    font-family: var(--exo-font-family-primary, sans-serif);
    font-weight: var(--exo-font-weight-semibold, 600);
    line-height: 1;
    z-index: 1;
    pointer-events: none;
    box-sizing: content-box;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 6%);
  }

  /* Dot specific styles */
  :host .indicator--dot {
    background-color: var(--exo-palette-coral-50, #ff7c66);
    border-color: var(--exo-palette-coral-20, #ffcbc2);
    width: var(--exo-spacing-x-small, 8px);
    height: var(--exo-spacing-x-small, 8px);
    padding: 0;
    font-size: 0; /* Hide any accidental text */
    color: transparent;
  }

  /* Count specific styles */
  :host .indicator--count {
    background-color: var(--exo-palette-coral-20, #fde8e5);
    min-width: var(--exo-spacing-3, 12px);
    max-width: var(--exo-spacing-6, 24px);
    height: auto;
    padding: 1px var(--exo-spacing-1, 4px);
    font-size: calc(var(--exo-font-size-x-large, 20px) / 2);
    font-weight: 400;
    box-sizing: border-box;
    color: var(--exo-palette-brand, #072b55);
  }
`;
var m = Object.defineProperty, w = Object.getOwnPropertyDescriptor, c = (o, r, n, e) => {
  for (var i, l = e > 1 ? void 0 : e ? w(r, n) : r, d = o.length - 1; d >= 0; d--)
    (i = o[d]) && (l = (e ? i(r, n, l) : i(l)) || l);
  return e && l && m(r, n, l), l;
}, z = ((o) => (o.PRIMARY = "primary", o.SECONDARY = "secondary", o.TERTIARY = "tertiary", o))(z || {}), $ = ((o) => (o.DEFAULT = "default", o.SMALL = "small", o.XSMALL = "x-small", o))($ || {}), E = ((o) => (o.BASE = "base", o.BRANDED = "branded", o.RISKY = "risky", o.PERIWINKLE = "periwinkle", o.PERIWINKLE_GREEN = "periwinkle_green", o))(E || {});
class t extends g {
  constructor() {
    super(...arguments), this.type = "primary", this.flavor = "branded", this.size = "default", this.icon = "", this.label = "", this.tooltipText = "", this.hideBrowserTooltip = !1, this.disabled = !1, this.circular = !1, this.variant = h.DEFAULT, this.hover = !1, this.pressed = !1;
  }
  onClickEvent() {
    this.dispatchCustomEvent("onClick", {});
  }
  getIndicatorDetails() {
    if (this.indicator === !0)
      return { type: "dot", content: null };
    if (typeof this.indicator == "number" && this.indicator > 0) {
      const r = this.indicator;
      return { type: "count", content: r > 9 ? "9+" : r.toString() };
    }
  }
  renderButton() {
    const r = this.getIndicatorDetails(), n = b("icon-button", { "icon-button--primary": this.type === "primary", "icon-button--secondary": this.type === "secondary", "icon-button--tertiary": this.type === "tertiary", "icon-button--base": this.flavor === "base", "icon-button--branded": this.flavor === "branded", "icon-button--risky": this.flavor === "risky", "icon-button--periwinkle": this.flavor === "periwinkle" || this.flavor === "periwinkle_green" && this.type !== "primary", "icon-button--periwinkle-green": this.flavor === "periwinkle_green", "icon-button--size-default": this.size === "default", "icon-button--size-small": this.size === "small", "icon-button--size-x-small": this.size === "x-small", "icon-button--circular": this.circular, hover: this.hover, pressed: this.pressed }), e = b("indicator", r && { "indicator--dot": r.type === "dot", "indicator--count": r.type === "count" });
    return s` <button
      slot="anchor"
      role="button"
      class=${n}
      aria-disabled=${this.disabled}
      ?disabled=${this.disabled}
      aria-label=${this.label || this.icon}
      @click=${this.onClickEvent}
      part="icon-button ${this.type} ${this.flavor}"
    >
      <ex-icon
        hide-browser-tooltip=${this.hideBrowserTooltip}
        icon=${this.icon}
        type=${this.type}
        flavor=${this.flavor === "periwinkle_green" ? "periwinkle" : this.flavor}
        variant=${this.variant}
        label=${this.label || this.icon}
      ></ex-icon>
      ${r ? s`<span
            part="indicator indicator-${r.type}"
            class=${e}
            aria-hidden="true"
          >
            ${r.content}
          </span>` : x}
    </button>`;
  }
  render() {
    return this.tooltipText && this.tooltipText.trim() !== "" ? s`
          <ex-tooltip position="top" alignment="middle" slot="anchor">
            <div>${this.tooltipText}</div>
            ${this.renderButton()}
          </ex-tooltip>
        ` : s`${this.renderButton()}`;
  }
}
t.styles = f, c([a()], t.prototype, "type", 2), c([a()], t.prototype, "flavor", 2), c([a()], t.prototype, "size", 2), c([a()], t.prototype, "icon", 2), c([a()], t.prototype, "label", 2), c([a()], t.prototype, "tooltipText", 2), c([a({ attribute: "hide-browser-tooltip" })], t.prototype, "hideBrowserTooltip", 2), c([a({ type: Boolean, reflect: !0 })], t.prototype, "disabled", 2), c([a({ type: Boolean })], t.prototype, "circular", 2), c([a()], t.prototype, "variant", 2), c([a({ type: Boolean })], t.prototype, "hover", 2), c([a({ type: Boolean })], t.prototype, "pressed", 2), c([a({ attribute: "indicator", converter: (o) => {
  if (o == null || o.toLowerCase() === "false")
    return;
  if (o === "" || o.toLowerCase() === "true")
    return !0;
  const r = Number(o);
  return Number.isNaN(r) ? void 0 : r;
} })], t.prototype, "indicator", 2);
const A = (o = "") => {
  p("ex-icon-button", t, o), k(o), y(o);
};
export {
  z as I,
  $ as a,
  E as b,
  t as c,
  b as d,
  A as r
};
